<template>
  <div class="sectionOuterBox">
    <div class="sectionInnerBox textLeft py50">
      <v-container class="container">
        <v-row>
          <v-col cols="12" md="8">
            <div class="text28 cBlue fontWeightBold">{{ $t('about.story.title') }}</div>
            <div class="aboutContent">
              <p>{{ $t('about.story.paragraph1') }}</p>
              <p>{{ $t('about.story.paragraph2') }}</p>
              <p>{{ $t('about.story.paragraph3') }}</p>
              <p>{{ $t('about.story.paragraph4') }}</p>
            </div>
          </v-col>
          <v-col cols="12" md="4" class="aboutContentRight">
            <div>"{{ $t('about.story.quote') }}"</div>
            <div class="aboutClock" :alt="$t('about.story.clockImageAlt')"></div>
          </v-col>
        </v-row>
      </v-container>
      <div class="container">
        <div class="grid">
          <div class="col-md-8">
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class Story extends Vue {
}
</script>

<style lang="scss" scoped>
.aboutContent {
  line-height: 28px;
  padding-top: 30px;
  padding-right: 50px;
}

.aboutContentRight>div:first-child {
  font-size: 32px;
  line-height: 42px;
  padding: 55px 30px 30px 30px;
}

.aboutClock {
  background-image: url('https://cdn.planbook.com/images/welcome-about-clock.png');
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  min-height: 300px;
}

.aboutContent p:not(:last-child) {
  margin-bottom: 30px;
}
</style>
